import { render, staticRenderFns } from "./followers.vue?vue&type=template&id=ed2cd300&"
import script from "./followers.vue?vue&type=script&lang=js&"
export * from "./followers.vue?vue&type=script&lang=js&"
import style0 from "./followers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports